import React, { FC, PropsWithChildren, useMemo } from "react";
import { LayoutChangeEvent, StyleProp, View, ViewStyle } from "react-native";
import { style as footerStyle } from "./Footer.style";

interface FooterProps extends PropsWithChildren {
  readonly style?: StyleProp<ViewStyle>;
  readonly onLayout?: (event: LayoutChangeEvent) => void;
}

const Footer: FC<FooterProps> = ({ children, style: customStyle, onLayout }) => {
  const style = useMemo(() => footerStyle(), []);

  return (
    <View style={[style.footer, customStyle]} onLayout={onLayout}>
      {children}
    </View>
  );
};

export { Footer };
